import clsx from 'clsx';
import React, { useCallback, useMemo } from 'react';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { SORT_ORDER } from '../../../constants';

const ThWithSort = ({ label, columnKey, width, onSort, sort, extraThClass, sortStr, isLeft }) => {
  const isAsc = useMemo(
    () => (columnKey === sort?.key && sort?.order === SORT_ORDER.ASC) || sortStr === columnKey,
    [sort, columnKey, sortStr],
  );
  const isDesc = useMemo(
    () => (columnKey === sort?.key && sort?.order === SORT_ORDER.DESC) || sortStr === `-${columnKey}`,
    [sort, columnKey, sortStr],
  );
  const isActive = isAsc || isDesc;

  const handleSort = useCallback(() => {
    if (!columnKey) {
      return;
    }

    onSort(columnKey);
  }, [columnKey, onSort]);

  return (
    <div className={clsx('th', isLeft && 'th--left', extraThClass)} style={{ width }}>
      <button onClick={handleSort} className={clsx('table-sort_button', isActive && 'table-sort_button--active')}>
        <span>{label}</span>
        <div className='table-sort-buttons'>
          <Icon icon={ICONS.FilledCaretUp} className={clsx('icon', 'icon--up', isActive && isAsc && 'icon--active')} />
          <Icon
            icon={ICONS.FilledCaretDown}
            className={clsx('icon', 'icon--down', isActive && !isAsc && 'icon--active')}
          />
        </div>
      </button>
    </div>
  );
};

export default ThWithSort;
